<template>
  <div class="">
    <el-select v-if="showSurveySelsct" :style="surveySelectWidth?{width:surveySelectWidth}:''" class="mr-2 select-bg-white" v-model="seSurveyId" :disabled="disabled" @change="ChangeSurveyId" placeholder="请选择">
      <el-option
        v-for="s of surveyList"
        :key="s.id"
        :label="s.name"
        :value="s.id">
      </el-option>
    </el-select>
    <el-select  v-if="showQuestionSelsct" :style="quesSelectWidth?{width:quesSelectWidth}:''" class="mr-2 select-bg-white" v-model="seQuestionId" :disabled="disabled" @change="changeQuestionId" placeholder="请选择">
      <el-option
        v-for="q of seQuestionList"
        :key="q.id"
        :label="q.content.text"
        :value="q.id">
      </el-option>
    </el-select>
    <el-select v-if="showOptionSelsct" class="select-bg-white mr-2" v-show="showOptionRadioSelect" v-model="seOptionIds" :disabled="disabled"  @change="changeOption" placeholder="请选择">
      <el-option
        v-for="o of seOptionsList"
        :key="o.id"
        :label="o.content.text"
        :value="o.id">
      </el-option>
    </el-select>
    <el-select v-if="showOptionSelsct" class="select-bg-white mr-2" v-show="showOptionMulSelect" multiple v-model="seOptionIds" :disabled="disabled" @change="changeOptionArr" placeholder="请选择">
      <el-option
        v-for="o of seOptionsList"
        :key="o.id"
        :label="o.content.text"
        :value="o.id">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import {changeOptionListList} from '../cellSet'
import { mapGetters } from 'vuex'
import {getSurveyPreview } from '@/api/wenjuan/wjquestion'
import { convertQuestionList } from '@/question/factory'
const checkQuestionTypeList1=[1,2,12,13,27,32,34,37,38,39,40]
const checkQuestionTypeList2=[1,2,27,32,34,37,38,39,40]

export default {
  name: 'SelectList',
  components: {},
  data() {
    return {
      seSurveyId:null,
      seQuestionId:null,
      seOptionIds:null,
      showOptionRadioSelect:false,
      showOptionMulSelect:false,
      seQuestionList:[],
      seOptionsList:[],
      waitUpdataOption:false,
    }
  },
  props: {
    surveyList:{
      type: Array,
      default: () => []
    },
    questionList:{
      type: Array,
      default: () => []
    },
    optionsList:{
      type: Array,
      default: () => []
    },
    surveyId:{
      type: String,
      default: ''
    },
    questionId:{
      type: String,
      default: ''
    },
    optionIds:{
      type: Array | String,
      default: () => []
    },
    showSurveySelsct:{
      type: Boolean,
      default:true
    },
    showQuestionSelsct:{
      type: Boolean,
      default:true
    },
    showOptionSelsct:{
      type: Boolean,
      default:true
    },
    questionType:{
      type: Number,
      default:0
    },
    isSample:{
      type: Boolean,
      default:false
    },
    disabled:{
      type: Boolean,
      default:false
    },
    root:{
      type: String,
      default: ''
    },
    surveySelectWidth:{
      type: String,
      default: ''
    },
    quesSelectWidth:{
      type: String,
      default: ''
    },

  },
  watch: {
    surveyId(val){
      if(val && this.seSurveyId!=val){      
        this.seSurveyId=this.surveyId
        this.changeQuestList(val)

      }
    },
    questionId(val){
      if(val && this.seQuestionId!=val){
        this.seQuestionId=this.questionId
        if(this.seQuestionList.length>0){
          this.changeOptListList(this.seQuestionId)
        }
      }
    },
    optionIds(val){
      if(val && this.seOptionIds!=val){
        this.seOptionIds=val
         if(this.seQuestionList.length>0 && this.questionId){
          this.changeOptListList(this.seQuestionId)
        }
      }
    },
    seQuestionList(){
      if(this.questionId && this.seQuestionList.length>0){
          this.changeOptListList(this.seQuestionId)
        }

    }
  },
computed:{
  ...mapGetters(['indexSurveyInfoList']),
},
  mounted(){
    this.seQuestionList=this.questionList
    this.seOptionsList=this.optionsList
    this.seQuestionId=this.questionId
    if(this.seQuestionId){
      this.waitUpdataOption=true
    }
    this.seSurveyId=this.surveyId
    if(this.seSurveyId){
      this. changeQuestList(this.seSurveyId)
    }
    this.seOptionIds=this.optionIds
  },
  methods:{
    changeQuestList(surveyId) {
      this.quesListLoading=true
      let list=this.indexSurveyInfoList[surveyId]
      if(!list){
        getSurveyPreview(surveyId).then(res=>{
          const { code, data } = res.data
          if (code === 0) {
            let qlist=data?.pageQuestions || []
            qlist = convertQuestionList(qlist)
            this.$store.commit('SET_INDEX_SURVRY_INFO_LIST',Object.assign(this.indexSurveyInfoList || {},{[surveyId]:qlist}))
            if(this.root=='range'){
              qlist=qlist.filter(val=>checkQuestionTypeList1.includes(val.question_type))
            }else if(this.root=='calcul'){
              qlist=qlist.filter(val=>checkQuestionTypeList2.includes(val.question_type) || (val.question_type==7 && val.issue.validate=='num'))
            }
            this.seQuestionList = qlist
            // if(this.waitUpdataOption){
            //   this.waitUpdataOption=false
            //   this.changeOptListList(this.questionId)
            // }
          }else{
            this.seQuestionList = []
          }
        })
      }else{
        if(this.root=='range'){
           list=list.filter(val=>checkQuestionTypeList1.includes(val.question_type))
        }else if(this.root=='calcul'){
          list=list.filter(val=>checkQuestionTypeList2.includes(val.question_type) || (val.question_type==7 && val.issue.validate=='num'))
        }
        this.seQuestionList=list
        // if(this.waitUpdataOption){
        //   this.waitUpdataOption=false
        //   this.changeOptListList(this.questionId)
        // }
      }
      
    },
    ChangeSurveyId(surveyId){
      this.changeQuestList(surveyId)
      this.seQuestionId=null
      this.seOptionIds=[]
      this.seOptionsList=[]
      this.showOptionRadioSelect=false
      this.showOptionMulSelect=false
      this.$emit('update:surveyId',surveyId)
      const survey= this.surveyList.find((val)=>val.id==surveyId)
      this.$emit('update:isSample',survey.isSample)
      this.$emit('update:questionId',null)
      this.$emit('update:questionType',0)
      this.$emit('update:optionIds',[])
      this.$emit('clearOptionIds')
      this.$emit('update:optionsList',[])

    },
    changeQuestionId(id){
      let result=changeOptionListList(this.seQuestionList,id,this.root)
      this.seOptionsList=result.list
      this.showOptionRadioSelect=result.showRadio
      this.showOptionMulSelect=result.shoMul
      this.seOptionIds=[]
      this.$emit('update:questionId',id)
      this.$emit('update:questionType',result.questionType)
      this.$emit('update:optionIds',[])
      this.$emit('clearOptionIds')
      this.$emit('update:optionsList',result.list)
      this.$emit('changeQues')
    },
    changeOptListList(id){
      let result=changeOptionListList(this.seQuestionList,id,this.root)
      this.seOptionsList=result.list
      this.showOptionRadioSelect=result.showRadio
      this.showOptionMulSelect=result.shoMul
      if(result.showRadio && Array.isArray(this.seOptionIds)){
        this.seOptionIds= this.seOptionIds.join(',')
      }
      if(result.shoMul && !Array.isArray(this.seOptionIds)){
        this.seOptionIds= this.seOptionIds.split(',')
      }
    },
    changeOption(id){
      this.$emit('update:optionIds',[id])
    },
    changeOptionArr(id){
      this.$emit('update:optionIds',id)
    }
  }
}
</script>

<style lang="scss" scoped>


</style>